import React, {useEffect} from 'react';
import CMSFactory from "factories/CMS";
import ShortBanner from "components/Home/ShortBanner/";
import DoubleShelfSlider from 'components/Home/DoubleShelfSlider';
import ShelfTabSlider from "components/Home/ShelfTabSlider";
import HighLights from "components/Home/HighLights";
import SliderProductsBanner from "components/Home/SliderProductsBanner";
import CategoriesOffers from "containers/CategoriesOffers";
import TodayOffers from "components/Home/TodayOffers";
import SliderBannerOffers from "components/Home/SliderBannerOffers";
import ProductsRecipes from "components/ProductsRecipes";
import JumboWorld from 'components/Home/JumboWorld';
import SimpleSliderBanner from 'components/Home/SimpleSliderBanner';
import Video from 'components/Home/Video';
import Recipes from 'components/Home/Recipes';
import BannerCategories from 'components/School/BannerCategories';
import VideoImageText from 'components/Home/VideoImageText';
import BannerTimer from 'components/Home/BannerTimer';
import ShelfTab from 'components/Home/ShelfTab';
import GridImageText from 'components/Home/GridImageText';
import CarouselGrid from 'components/Home/CarouselGrid';
import NewShelfTabSlider from "components/Home/NewShelfTabsSlider";
import OutstandingPrefooter from 'components/Home/OutstandingPrefooter';
import SmallInformative from 'components/Home/SmallInformative';
import FeaturedShowcase from 'components/Home/FeaturedShowcase';
import GridSolidFunds from 'components/Home/GridSolidFunds';
import GridTwoOverTwo from 'components/Home/GridTwoOverTwo';
import GridTextAndCardSmallOrMedium from 'components/Home/GridTextAndCardSmallOrMedium';
import FeaturedWithButton from 'components/Home/FeaturedWithButton';
import GridTextImageMedium from 'components/Home/GridTextImageMedium';
import TextComponent from 'components/TextComponent';


let countSliderProductsBanner = 0;
let countRecipes = 0;
let countSliderBannerOffers = 0;
let countProductOffers = 0;
let countShortB = 0;
let countSliderCategoriesOffers = 0;
let countBannerTimer = 0;
let countShelfSlider = 0;
let countIslandImgText = 0;
let shelfIsland = 0;
let secondaryBanner = 0;
let gridTwoOverTwo = 0;
let carouselImageGrid = 0;
let featuredShowcase = 0;
let gridSolidFunds = 0;
let gridTextAndCardSmallOrMedium = 0;
let featuredWithButton = 0;
let gridTextImageMedium = 0;
let textComponent = 0;

let positionElements = {};
let countElements = {};

const HomeSections = (props) => {
    const { element, i, dateServer } = props;

    if (!element || !element.acf_fc_layout) return '';

    useEffect(() => {
        return function cleanup() {
            shelfIsland = 0;
            countSliderProductsBanner = 0;
            countRecipes = 0;
            countSliderBannerOffers = 0;
            countProductOffers = 0;
            countShortB = 0;
            countSliderCategoriesOffers = 0;
            countBannerTimer = 0;
            countShelfSlider = 0;
            countIslandImgText = 0;
            secondaryBanner = 0;
            gridTwoOverTwo = 0;
            carouselImageGrid = 0;
            featuredShowcase = 0;
            gridSolidFunds = 0;
            gridTextAndCardSmallOrMedium = 0;
            featuredWithButton = 0;
            gridTextImageMedium = 0;

            positionElements = {};
            countElements = {};
        }
    }, []);

    const validateDates = (serverDate, _element) => {
        let startDate = _element.start_date ? CMSFactory.milliseconds(_element.start_date) : '';
        let endDate = _element.end_date ? CMSFactory.milliseconds(_element.end_date) : '';

        if (startDate && (startDate >= serverDate)) return false;
        if(endDate && (serverDate >= endDate)) return false;

        return true;
    };

    const idPosition = element.acf_fc_layout + i;

    switch (element.acf_fc_layout) {
        case 'short_banner':
        {
            if (!validateDates(dateServer, element)) return '';
            countShortB++;
            element.countShortB = countShortB;
            return (element.active && <ShortBanner key={i} data={element} /> );
        }

        case 'shelf_tab_slider':
            if(!countElements[element.acf_fc_layout]){
                countShelfSlider++;
                countElements[element.acf_fc_layout]  = countShelfSlider;
            }
            element.countSliderProductsBanner = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }
            element.shelfIsland = positionElements[idPosition];

            return <ShelfTabSlider key={i} data={element} date={dateServer} />;

        case 'high_lights':
            return <HighLights  key={i} data={element} date={dateServer} /> ;

        case 'double_shelf_slider':
            return <DoubleShelfSlider data={element} date={dateServer} />;

        case 'banners':
            return  <SimpleSliderBanner key={i} data={element.content} title={element.title} date={dateServer}/>;

        case 'offers_today':
            if (!validateDates(dateServer, element)) return '';

            if(!countElements[element.acf_fc_layout]){
                countElements[element.acf_fc_layout]  = countProductOffers;
                countProductOffers++;
            }
            element.countProductOffers = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }
            element.shelfIsland = positionElements[idPosition];
            return (element.content[1].category != false && element.active &&  <TodayOffers key={i} item={element} date={dateServer}/> );

        case 'shelf_slider_destacados':
            if (!validateDates(dateServer, element)) return '';

            if(!countElements[element.acf_fc_layout]){
                countSliderProductsBanner++;
                countElements[element.acf_fc_layout]  = countSliderProductsBanner;
            }
            element.countSliderProductsBanner = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }
            element.shelfIsland = positionElements[idPosition];
            return (element.active &&  <SliderProductsBanner key={i} item={element} /> );

        case 'offer_category':
            element.serverDate = dateServer;

            if(!countElements[element.acf_fc_layout]){
                countSliderCategoriesOffers++;
                countElements[element.acf_fc_layout]  = countSliderCategoriesOffers;
            }
            element.countSliderCategoriesOffers = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }
            element.shelfIsland = positionElements[idPosition];
            return (element.active &&  <CategoriesOffers key={i} item={element} /> );

        case 'small_banner_offer':
            element.serverDate = dateServer;
            if (!validateDates(dateServer, element)) return '';

            if(!countElements[element.acf_fc_layout]){
                countSliderBannerOffers++;
                countElements[element.acf_fc_layout]  = countSliderBannerOffers;
            }
            element.countSliderBannerOffers = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                secondaryBanner++;
                positionElements[idPosition] = secondaryBanner;
            }
            element.secondaryBanner = positionElements[idPosition];
            return (element.active ?  <SliderBannerOffers key={i} item={element} date={dateServer} /> : '');

        case 'mun_jumbo':
            element.serverDate = dateServer;
            return <JumboWorld key={i} item={element} />;
        case 'recipe':
            element.serverDate = dateServer;
            if (!validateDates(dateServer, element)) return '';

            if(!countElements[element.acf_fc_layout]){
                countRecipes++;
                countElements[element.acf_fc_layout]  = countRecipes;
            }
            element.countRecipes = countElements[element.acf_fc_layout];

            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }
            element.shelfIsland = positionElements[idPosition];
            return (element.active && <ProductsRecipes key={i} item={element} />);

        case 'video':
            return(<Video key={i} data={element} date={dateServer} validateDates={validateDates} />);

        case 'newrecipe':
            element.serverDate = dateServer
            if (!validateDates(dateServer, element)) return '';

            return (element.active && <Recipes data={element} date={dateServer} validateDates={validateDates}/>);

        case 'vid_img_txt':
            element.serverDate = dateServer
            if (!validateDates(dateServer, element)) return '';
            return(element.active && <VideoImageText key={i} data={element} date={dateServer} />);

        case 'grid_image':
            element.serverDate = dateServer
            if (typeof element.active === 'boolean' && !(validateDates(dateServer, element) && element.active)) return '';
            return (<BannerCategories categories={element} dateServer={dateServer}/>);

        case 'banner_with_timer':
            if (!(validateDates(dateServer, element) && element.active)) return '';
            countBannerTimer++;
            element.countBannerTimer = countBannerTimer;
            return (<BannerTimer data={element} dateServer={dateServer} />);

        case 'tabs_slider':
            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }

            element.shelfIsland = positionElements[idPosition];

            return (<ShelfTab data={element} dateServer={dateServer} />)

        case 'island_image_and_text':
            element.serverDate = dateServer
            if (!(validateDates(dateServer, element) && element.active)) return '';

            if(!positionElements[idPosition]){
                countIslandImgText++;
                positionElements[idPosition] = countIslandImgText;
            }

            element.countIslandImgText = positionElements[idPosition];

            return (<GridImageText data={element} dateServer={dateServer} key={i}/>)

        case 'grid_2-2_video_image':
            if(!positionElements[idPosition]){
                gridTwoOverTwo++;
                positionElements[idPosition] = gridTwoOverTwo;
            }
            element.position = positionElements[idPosition];
            return (<GridTwoOverTwo key={i} data={element} dateServer={dateServer} />)


        case 'tabs_slider_v2':
            if(!positionElements[idPosition]){
                shelfIsland++;
                positionElements[idPosition] = shelfIsland;
            }

            element.shelfIsland = positionElements[idPosition];

            return <NewShelfTabSlider key={i} data={element} dateServer={dateServer} />;
        
        case 'carousel_image_grid':
            element.serverDate = dateServer
            if (!(validateDates(dateServer, element) && element.active)) return '';

            if(!positionElements[idPosition]){
                carouselImageGrid++;
                positionElements[idPosition] = carouselImageGrid;
            }

            element.carouselImageGrid = positionElements[idPosition];

            return <CarouselGrid data={element} dateServer={dateServer} key={i}/>;
            
        case 'featured_showcase':
            element.serverDate = dateServer
            if (!(validateDates(dateServer, element) && element.active)) return '';

            if(!positionElements[idPosition]){
                featuredShowcase++;
                positionElements[idPosition] = featuredShowcase;
            }

            element.featuredShowcase = positionElements[idPosition];

            return <FeaturedShowcase data={element} dateServer={dateServer} key={i}/>;

        case 'featured_with_button':
            element.serverDate = dateServer
            if (!(validateDates(dateServer, element) && element.active)) return '';

            if(!positionElements[idPosition]){
                featuredWithButton++;
                positionElements[idPosition] = featuredWithButton;
            }

            element.featuredWithButton = positionElements[idPosition];

            return <FeaturedWithButton data={element} dateServer={dateServer} key={i}/>;

        case 'outstanding_prefooter':
        {
            if (!(validateDates(dateServer, element) && element.active)) return ''
            return (<OutstandingPrefooter key={i} data={element} />);
        }
        case 'grid_text_and_card_small_or_medium':
            if (!positionElements[idPosition]) {
                gridTextAndCardSmallOrMedium++
                positionElements[idPosition] = gridTextAndCardSmallOrMedium
            }
            element.position = positionElements[idPosition]
            return <GridTextAndCardSmallOrMedium key={i} data={element} dateServer={dateServer} />

        case 'small_informative':
            return <SmallInformative key={i} data={element} dateServer={dateServer} />;

        case 'grid_s_solid_funds':
            if(!positionElements[idPosition]){
                gridSolidFunds++;
                positionElements[idPosition] = gridSolidFunds;
            }
            element.position = positionElements[idPosition];
            return (<GridSolidFunds key={i} data={element} dateServer={dateServer} />)

        case 'island_text_image_m':
            if(!positionElements[idPosition]){
                gridTextImageMedium++;
                positionElements[idPosition] = gridTextImageMedium;
            }
            element.position = positionElements[idPosition];
            return (<GridTextImageMedium key={i} data={element} dateServer={dateServer} />)

        case 'component_text':
            if(!positionElements[idPosition]){
                textComponent++;
                positionElements[idPosition] = textComponent;
            }
            element.position = positionElements[idPosition];
            return (<TextComponent key={i} data={element} />)
        default:
            return '';
    }
}

export default HomeSections;
